import React from "react";
// import { domain, headers } from '../../Variables'
import Loader from 'react-loader-spinner'
import HttpServices from "../../utils/Http.services";
import { checkTranslation, translate } from "../../utils/useful";
// import AutosizeInput from 'react-input-autosize';

class MultiSelect extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            data: [],
            title: '',
            tempData: [],
            options: [],
            choosen: [],
            isLoading: true,
            isFinal: false,
        }
    }


    toggleOpen = (makeOpen) => {

        let final = makeOpen != null ? makeOpen : !this.state.isOpen
        if (final != this.state.isOpen) {
            if (!this.state.isOpen) {
                document.addEventListener('mousedown', this.closeBox);
            } else {
                document.removeEventListener('mousedown', this.closeBox);

            }
        }


        this.setState({ isOpen: final, data: this.props.data }, () => {
            // this.changePositionOnOpen()
        })

    }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            if (this.refs.icon)
                this.refs.icon.classList.toggle("rotate-180")

        }
    }


    changeItem = (prop, selected, dontChangeValue) => {
        // console.log("CHANGE")
        // console.log(prop)
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })
        // this.toggleOpen()


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {
                // console.log("HERE")

                if (choosen[i] == prop.title) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {

            if (!dontChangeValue) this.changeValue()
        })


        setTimeout(
            function () {
                this.toggleOpen(true)
            }
                .bind(this),
            1
        );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentWillMount() {
        // if (this.props.options) {
        //     if (this.props.options.type == "local") {
        //         this.setState({ options: this.props.options.items })
        //     } else if (this.props.options.type == "api") {
        // this.setState({data:[]})
        // console.log(this.props.data)

        if (this.props.data?.length > 0) {
            this.loopInit(-1)
        } else {
            this.changeFilter()
        }
        // }
        // }

        // if (this.props.data.length > 0) {

        //     this.loopInit(-1)
        // }
    }


    componentDidUpdate(prevProps) {
        if ((JSON.stringify(prevProps.data) != JSON.stringify(this.props.data)) && (this.state.choosen.length != this.props.data?.length) && (prevProps.title == null || prevProps.title == '' || prevProps.title == [])) {
            if (this.props.data?.length > 0) {

                this.loopInit(-1)
            }
        }
    }


    loopInit = (count) => {

        // console.log("LOOPINIT")

        this.changeFilter(this.props.data[count], (result) => {

            if (result != -1) {

                result.forEach(element => {

                    if (element.value == (this.props.data[count + 1]?._id ?? this.props.data[count + 1])) {
                        this.changeItem(element, false, true)
                    }
                });
                this.loopInit(count + 1)
            }
        })

    }


    changeFilter(refValue, cb) {
        let newFilter = this.props.header.information?.filter
        newFilter[this.props.header.information.reference] = refValue ? refValue : this.props.header.information.root

        for (const [key, value] of Object.entries(newFilter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    newFilter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    if (typeof newFilter[key] == 'object') {
                        newFilter[key] = newFilter[key]._id
                    }
                }
            }
        }
        // console.log(newFilter)

        this.fetch(newFilter, cb ? cb : null)
    }



    fetch(filter, cb) {
        // console.log("FETCH")
        this.setState({ options: [] })
        this.setState({ isLoading: true })

        HttpServices.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {



            // fetch(this.props.header.information.address, {
            //     method: 'POST',
            //     body: JSON.stringify({ filter: filter }),
            //     // headers: headers
            // }).then(response => response.json()).then(data => {
            // if (data.status == 200) {
            // console.log(fetchResult)
            var newData = []
            if (fetchResult.info.length > 0) {
                fetchResult.info.forEach(element => {

                    var newTitle = this.spliter(element, this.props.header.information.fields.title)
                    var newValue = this.spliter(element, this.props.header.information.fields.value)

                    newData.push({ value: newValue, title: newTitle })
                });
                this.setState({
                    options: newData,
                    tempData: newData,
                    isLoading: false
                })
                if (cb) {
                    // console.log("FETCH DONE")

                    cb(newData)
                }
            } else {
                if (this.state.choosen.length > 0) {
                    this.setState({ isFinal: true }, () => {
                        this.changeValue()
                        this.toggleOpen(false)
                    })
                }
                this.setState({
                    isLoading: false
                }, () => {

                    if (cb) {
                        cb(-1)
                    } else {
                        // this.changeValue()
                    }
                })
            }
            // }
        })
        // }).catch(error => this.setState({ error, isLoading: false }));
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen(true)
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            this.state.tempData.forEach(element => {
                if (element.title.toLowerCase().includes(value.toLowerCase())) {
                    values.push(element)
                }
            })

            this.setState({ options: values })

        }
    }


    removeItem(index) {
        let newChoosen = [...this.state.choosen]
        newChoosen.splice(index, this.state.choosen.length - index)
        this.setState({ choosen: newChoosen, isFinal: false }, () => {
            this.changeFilter(this.state.choosen.length ? this.state.choosen[this.state.choosen.length - 1].value : this.props.header.information.root)
            this.changeValue(true)

        })
        this.toggleOpen()
    }


    changeValue(empty) {
        let choosen = []
        if (!empty) {
            this.state.choosen.forEach(element => {
                choosen.push(element.value)
            });
        }
        if (choosen.length == 0) {
            choosen = ''
        }
        // console.log("choosen")
        // console.log(choosen)
        this.props.changeValue(this.props.header.key, choosen, { isFinal: this.state.isFinal })
    }


    render() {
        // console.log("choosen", this.state.choosen)

        return (
            <div className='mt-0 ' style={{ width: '100%', position: 'relative' }} >




                <div ref={ref => this.setWrapperRef(ref)} >
                    <div onClick={() => { if (this.refs.input) this.refs.input.focus() }} style={{ flexWrap: 'wrap', cursor: 'pointer', minHeight: 30, display: 'flex', alignItems: 'center' }}>

                        {this.state.choosen?.length == 0 && this.state.title == '' && (
                            <p className="placeholder position-absolute px-1" style={{ top: 5 }}>{checkTranslation(this.props.header.information?.placeholder) ?? translate('Select')}</p>
                        )}

                        {this.state.choosen.map((prop, index) => {
                            return (
                                <div className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                    <div key={index} style={{ padding: 5, backgroundColor: '#78b2d020', borderRadius: 4, marginRight: 2, marginLeft: 2, display: 'flex', flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>
                                        <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{prop.title}</p>
                                        <div>
                                            <img className="mld-1" src="/images/close.svg" height="14px" onClick={() => this.removeItem(index)} style={{ padding: 2, paddingLeft: 0, opacity: 0.4, color: '#78b2d0' }} />
                                        </div>
                                    </div>
                                    {index != this.state.choosen.length - 1 && (
                                        <img src="/images/next.png" height="16px" style={{ opacity: 0.1 }} />

                                    )}
                                </div>
                            )
                        })}
                        <div className={"position-relative mt-0 mld-1 "}>
                            {!this.state.isFinal && (
                                <input ref={'input'} value={this.state.title} onFocus={() => this.toggleOpen(true)} onInput={event => this.search(event.target.value)} className='nofocus mediumiransansfont' style={{ backgroundColor: 'transparent', minWidth: 100, width: this.state.title.length * 9, border: 'none' }} />
                            )}
                            {this.state.isLoading && (
                                <div style={{ position: 'absolute', top: 1, left: 5 }}>
                                    <Loader
                                        type="Oval"
                                        color="rgba(0,122,255,1)"
                                        height="20"
                                        width="20"
                                    />
                                </div>
                            )}
                        </div>
                        {this.state.isFinal && (<img src="/images/check.png" height="20px"  alt=""/>)}

                    </div>

                    {this.state.isOpen && (
                        <div style={{ display: 'flex', position: 'absolute', width: '100%', zIndex: 40 }}>
                            <div className={'search-drop-down'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#fff', borderColor: '#eee', borderRadius: 4, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>
                                {/* {this.props.isSearchable && (<input onChange={event => this.search(event.target.value)} placeholder={"جست و جو ..."} style={{ fontSize: 13, textAlign: 'center', direction: 'rtl', alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'mediumiransansfont'} />)} */}

                                {this.state.options.map((prop, index) => {
                                    let selected = false
                                    for (var i = 0; i < this.state.choosen.length; i++) {

                                        if (prop.title == this.state.choosen[i])
                                            selected = true
                                    }
                                    return (
                                        <div key={index} onClick={() => this.changeItem(prop, selected, true)} style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1, backgroundColor: selected ? '#f7f7f7' : '#fff' }}>
                                            <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{prop.title}</p>
                                        </div>
                                    )
                                })}

                                {this.state.options.length == 0 && (
                                    <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>Found Nothing</p>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}

                </div>



            </div>
        );
    }
}


export default MultiSelect;
